import React, { useCallback, useEffect, useRef } from 'react';
import { Icon, IconsEnum } from 'components/Icons';
import { ScommesseFilterItem, ScommesseFiltersListProps } from 'components/scommesseFiltersList';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import classNames from 'classnames';
import { selectTemplateSlug } from 'features/sport';
import { setIndexFilterTipiScommessa } from 'features/sport/sportSlice';
import styles from './ScommesseFiltersList.module.scss';
import { useIsDarkTheme } from 'hooks/useIsDarkTheme';
import { useTranslation } from 'hooks/useLingUI';

export const ScommesseFiltersList = ({
  items,
  className,
  selectedIndex,
  hasMarginBottom,
  removeTitle,
  onSelectedFilter,
}: ScommesseFiltersListProps) => {
  const { t } = useTranslation();
  const { isDarkMode } = useIsDarkTheme();

  const dispatch = useAppDispatch();
  const templateSlug = useTypedSelector(selectTemplateSlug);
  const refTemplateSlug = useRef<string | undefined>(templateSlug);

  const handleToggle = useCallback(
    (index: number) => {
      if (typeof onSelectedFilter === 'function') {
        onSelectedFilter(index);
      } else {
        dispatch(setIndexFilterTipiScommessa(index));
      }
    },
    [dispatch, onSelectedFilter]
  );

  useEffect(() => {
    if (refTemplateSlug.current !== templateSlug) {
      refTemplateSlug.current = templateSlug;
      handleToggle(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateSlug]);

  return (
    <div className={classNames(styles.container, className ?? '', { [styles.marginBottom]: hasMarginBottom })}>
      {items &&
        items.map((item: ScommesseFilterItem, index) => {
          const { label, labelTrKey, title, titleTrKey, hasNew } = item;
          return (
            <div className={styles.buttonWrapper} key={`${item}_${index}`}>
              {title && !removeTitle && (
                <p suppressHydrationWarning className={styles.title}>
                  {t(titleTrKey, title)}
                </p>
              )}
              <button
                type="button"
                className={`${styles.button} ${selectedIndex === index ? styles.active : ''}`}
                onClick={() => {
                  handleToggle(index);
                }}
              >
                {label && t(labelTrKey, label)}
                {hasNew && (
                  <Icon iconId={isDarkMode ? IconsEnum.NEW_DARK : IconsEnum.NEW_LIGHT} className={styles.iconNew} />
                )}
              </button>
            </div>
          );
        })}
    </div>
  );
};